<template>
  <div class="frame-chrome d-flex align-center flex-grow-1" style="min-width: 0">
    <router-link to="/" class="frame-brand"><b>GASPRE</b><span>intra</span></router-link>
    <nav class="frame-top__nav" aria-label="Peamenüü">
      <template v-for="item in main" :key="item.text">
        <v-menu v-if="item.children" location="bottom start" :offset="2">
          <template #activator="{ props }">
            <button class="frame-tab" :class="{ 'is-on': groupOn(item) }" type="button" v-bind="props">
              {{ item.text }}<v-icon size="18">mdi-chevron-down</v-icon>
            </button>
          </template>
          <div class="frame-pop frame-dd">
            <template v-for="(child, i) in item.children" :key="i">
              <template v-if="child.children">
                <span class="frame-dd__label frame-dd__label--nested">{{ child.text }}</span>
                <router-link
                  v-for="(grand, j) in child.children"
                  :key="j"
                  :to="grand.link"
                  class="frame-dd__nested"
                  :class="{ 'is-on': isOn(grand.link) }"
                >{{ grand.text }}</router-link>
              </template>
              <router-link v-else :to="child.link" :class="{ 'is-on': isOn(child.link) }">{{ child.text }}</router-link>
            </template>
          </div>
        </v-menu>
        <a v-else-if="item.href" :href="item.href" class="frame-tab">
          {{ item.text }}<span v-if="item.badge" class="frame-badge" :title="item.badgeTitle">{{ item.badge }}</span>
        </a>
        <router-link
          v-else
          :to="item.link"
          class="frame-tab"
          :class="{ 'is-on': isOn(item.link) }"
          :aria-current="isOn(item.link) ? 'page' : undefined"
        >{{ item.text }}</router-link>
      </template>

      <!-- Kasutajad, Seaded and Süsteem do not fit in one row beside the rest,
           so on top they share one "Haldus" menu, each under its own name. -->
      <v-menu v-if="admin.length" location="bottom start" :offset="2">
        <template #activator="{ props }">
          <button class="frame-tab" :class="{ 'is-on': admin.some(groupOrLinkOn) }" type="button" v-bind="props">
            Haldus<v-icon size="18">mdi-chevron-down</v-icon>
          </button>
        </template>
        <div class="frame-pop frame-dd">
          <!-- Plain pages first, then each group under its own name, so a page
               never reads as part of the group above it. -->
          <template v-for="item in adminOrdered" :key="item.text">
            <template v-if="item.children">
              <span class="frame-dd__label">{{ item.text }}</span>
              <template v-for="(child, i) in item.children" :key="i">
                <template v-if="child.children">
                  <span class="frame-dd__label frame-dd__label--nested">{{ child.text }}</span>
                  <router-link
                    v-for="(grand, j) in child.children"
                    :key="j"
                    :to="grand.link"
                    class="frame-dd__nested"
                    :class="{ 'is-on': isOn(grand.link) }"
                  >{{ grand.text }}</router-link>
                </template>
                <router-link v-else :to="child.link" :class="{ 'is-on': isOn(child.link) }">{{ child.text }}</router-link>
              </template>
            </template>
            <router-link v-else :to="item.link" :class="{ 'is-on': isOn(item.link) }">{{ item.text }}</router-link>
          </template>
        </div>
      </v-menu>
    </nav>
  </div>
</template>

<script>
import frameLinks from './frameLinks'

export default {
  mixins: [ frameLinks ],
  props: {
    items: { type: Array, required: true }
  },
  computed: {
    main () {
      return this.items.filter(item => item.section !== 'admin')
    },
    admin () {
      return this.items.filter(item => item.section === 'admin')
    },
    adminOrdered () {
      return [...this.admin.filter(item => !item.children), ...this.admin.filter(item => item.children)]
    }
  },
  methods: {
    groupOrLinkOn (item) {
      return item.children ? this.groupOn(item) : this.isOn(item.link)
    }
  }
}
</script>
